// TODO: Dejar de usar, se están reemplazando por Strings
export const LOGOUT_POST = '/users/logout'
export const ROLES = '/roles'
export const ROLES_PATH = '/roles' // TODO: eliminar cuando no se use mas
export const ACTIVE_ROLES = '/roles/active' // TODO: eliminar cuando no se use mas
export const ALLOWED_ROLES = '/findAllowedRolesToAssign'
export const AUTHORIZATION_PATH = '/user/profile'
export const ACTIVE_USERS_PATH = '/users/active' // TODO: eliminar cuando no se use mas
export const GROUPS_PATH = '/groups'
export const ACTIVE_GROUPS_PATH = '/groups/active'
export const SEARCH_GROUPS_PATH = '/groups/search'
export const ASSIGN_GROUP_PATH = '/assign'
export const ACTIVE = '/active'
export const SEARCH = '/search'
export const THIRD_PARTY = '/terceros'
